module.exports = __webpack_public_path__ + "img/f.1dec53a9.png";